angular.module("Main").controller("AggregatorSuccessController", ["$rootScope", "$scope", "$localStorage", "$state", "$window", "$stateParams", "$location", "$translate", "AggregatorService", "BookingService", "SessionService",
    function ($rootScope, $scope, $localStorage, $state, $window, $stateParams, $location, $translate, AggregatorService, BookingService, SessionService) {
        var vm = this;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            vm.mandantNr = $stateParams.club;
            loadAggregatorenConfig();
        } else {
            vm.withoutClubsMenuItem = false;
            vm.cookies = SessionService.checkSession();
            if (!_.isNil(vm.cookies.aggregatorClubData)) {
                vm.clubData = vm.cookies.aggregatorClubData;
                vm.aggregatorData = vm.cookies.aggregatorData;
                vm.mandantNr = vm.clubData.selectedMandantNr;
                vm.mandatBezeichnung = vm.clubData.selectedMandantName;
                loadAggregatorenConfig();
            }
        }

        getKursbuchungLayouKonfiguration();
        loadAggregatorButton()

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadAggregatorenConfig() {
            vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
            BookingService.loadBestaetigungText(vm.mandant, vm.aggregatorData).then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }

        function loadAggregatorButton() {
            BookingService.loadBestaetigungButton().then(function (data) {
                vm.aggregatorenButton = data;
            })
        }

        vm.goToButton = function () {
            if(vm.aggregatorenButton.ButtonUrlStudio) {
                $window.location.href = vm.aggregatorenButton.UrlStudio;
            } else {
                $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id})
            }
        }

    }]);